import { createContext, type ReactNode, useContext, useState } from 'react';
import { useBangKeHoaDonBanHangExport } from './hooks/useBangKeHoaDonBanHangExport';

interface BangKeHoaDonBanHangContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  queryParams: BanHangRecord | null;
  setQueryParams: (params: BanHangTableParams | null) => void;
  exportSubtitle: string;
  setExportSubtitle: (subtitle: string) => void;
}

const BangKeHoaDonBanHangContext = createContext<BangKeHoaDonBanHangContextValue | null>(null);

export const useBangKeHoaDonBanHangContext = () => {
  const context = useContext(BangKeHoaDonBanHangContext);
  if (!context) {
    throw new Error('useBangKeHoaDonBanHangDichVuContext must be used within BangKeHoaDonBanHangDichVuProvider');
  }
  return context;
};

export const BangKeHoaDonBanHangDichVuProvider = ({ children }: { children: ReactNode }) => {
  const [queryParams, setQueryParams] = useState<BanHangRecord | null>(null);
  const [exportSubtitle, setExportSubtitle] = useState('');
  const { exportToExcel, canExport, isExporting } = useBangKeHoaDonBanHangExport(queryParams, exportSubtitle);

  return (
    <BangKeHoaDonBanHangContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting,
        queryParams,
        setQueryParams,
        exportSubtitle,
        setExportSubtitle
      }}
    >
      {children}
    </BangKeHoaDonBanHangContext.Provider>
  );
};
